<template>
  <div class="page-wrap">
    <div class="filter">
      <div class="header-title">监控预警</div>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="header-tab">
        <el-tab-pane label="预警通知" name="notice">
          <warn-notice @handleSearch="handleSearch"></warn-notice>
        </el-tab-pane>
        <el-tab-pane label="预警规则" name="rule">
          <warn-rule :list="ruleList" @successCallBack="getRuleList"></warn-rule>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="table" v-show="activeName === 'notice'">
      <div class="table-total">共{{ pageData.total }}条数据</div>
      <el-table
        :border="false"
        :data="list"
        ref="table"
        :max-height="tableHeight"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.1)"
      >
        <el-table-column
          v-for="item in noticeColumn"
          :prop="item.key"
          :label="item.name"
          :key="item.id"
          :width="item.width"
          :fixed="item.fixed"
          align="left"
        >
          <template slot-scope="scope">
            <div v-if="item.key === 'platform'">
              {{ platformList.find((item) => item.value === scope.row.platform).label || "--" }}
            </div>
            <div v-else-if="['remark'].includes(item.key)">
              <el-input
                v-if="editDataSet[scope.row.id]"
                type="textarea"
                :rows="2"
                placeholder="请输入后需调整"
                v-model="editDataSet[scope.row.id][item.key]"
              >
              </el-input>
              <div v-else>{{ scope.row[item.key] || "--" }}</div>
            </div>
            <div v-else-if="['warnReason'].includes(item.key)">
              <el-input
                v-if="editDataSet[scope.row.id] && editDataSet[scope.row.id].version === 0"
                type="textarea"
                :rows="2"
                placeholder="请输入异常原因"
                v-model="editDataSet[scope.row.id][item.key]"
              >
              </el-input>
              <div v-else>{{ scope.row[item.key] || "--" }}</div>
            </div>
            <div v-else>
              {{ scope.row[item.key] || "--" }}
              <svg-icon
                v-if="
                  scope.row[item.key] &&
                  statusList.find((child) => child.label === scope.row[item.key])
                "
                :iconClass="
                  (statusList.find((child) => child.label === scope.row[item.key]) || {}).key
                "
                className="icon"
              ></svg-icon>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operate" key="operate" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <div v-if="editDataSet[scope.row.id]" class="edit-btns">
              <el-button type="text" size="small" @click="saveData(scope.row)">保存</el-button>
              <el-button type="text" size="small" @click="cancel(scope.row)">取消</el-button>
            </div>
            <el-button v-else type="text" @click="handerClickEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <self-pagination
      v-if="activeName === 'notice'"
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      ref="tabelPagination"
      @getCurrentPage="changePage"
      @handleSizeChange="handleSizeChange"
    ></self-pagination>
    <self-pagination
      v-if="activeName === 'rule'"
      class="footer-page"
      :total="rulePageData.total"
      :pageSize="rulePageData.size"
      :currentPage="rulePageData.page"
      ref="tabelPagination"
      @getCurrentPage="changeRulePage"
      @handleSizeChange="handleRuleSizeChange"
    ></self-pagination>
  </div>
</template>

<script>
import WarnNotice from "./components/warnNotice";
import WarnRule from "./components/warnRule";
import { noticeColumn, platformList, statusList } from "./config";
import { getWarnRecordList, updateWarnRecord, getWarnRuleList } from "@/api/api";
import SvgIcon from "@/components/SvgIcon.vue";
import moment from "moment";
export default {
  components: {
    WarnNotice,
    WarnRule,
    SvgIcon,
  },

  data() {
    return {
      statusList,
      activeName: "notice",
      loading: false,
      noticeColumn,
      platformList,
      list: [],
      tableHeight: window.innerHeight - 350,
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      rulePageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      editDataSet: {},
      ruleList: [],
      searchData: {},
    };
  },

  computed: {},

  watch: {},
  mounted() {
    this.getRuleList();
  },

  methods: {
    getWarnRecordList(obj) {
      this.loading = true;
      const { formdate, warnType, afid } = obj || {};
      let params = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        startTime: moment(formdate[0]).format("YYYYMMDD"),
        endTime: moment(formdate[1]).format("YYYYMMDD"),
        warnType,
        afid,
      };
      getWarnRecordList(params)
        .then((res) => {
          this.loading = false;
          const { code, data, msg } = res;
          if (code == "0000") {
            this.list = data.list;
            this.pageData.total = data.total;
            this.pageData.size = data.pageSize;
            this.pageData.page = data.pageNum;
            this.loading = false;
          } else {
            this.$message({
              message: msg,
              type: "error",
            });
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          throw new Error(e);
        });
    },
    getRuleList() {
      getWarnRuleList({ pageNum: this.rulePageData.page, pageSize: this.rulePageData.size })
        .then((res) => {
          const { code, data, msg } = res;
          if (code == "0000") {
            this.ruleList = data.list;
            this.rulePageData.total = data.total;
            this.rulePageData.size = data.pageSize;
            this.rulePageData.page = data.pageNum;
          } else {
            this.$message({
              message: msg,
              type: "error",
            });
          }
        })
        .catch((e) => {
          throw new Error(e);
        });
    },
    handleClick() {},
    changePage(page) {
      this.pageData.page = page;
      this.getWarnRecordList(this.searchData);
    },
    handleSizeChange(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getWarnRecordList(this.searchData);
    },
    changeRulePage(page) {
      this.rulePageData.page = page;
      this.getRuleList();
    },
    handleRuleSizeChange(size) {
      this.rulePageData.page = 1;
      this.rulePageData.size = size;
      this.getRuleList();
    },
    handerClickEdit(row) {
      this.$set(this.editDataSet, row.id, JSON.parse(JSON.stringify(row)));
    },
    saveData(row) {
      let curRow = this.list.find((item) => item.id === row.id);
      let reqData = Object.assign(JSON.parse(JSON.stringify(curRow)), this.editDataSet[row.id]);
      const { id, remark, warnReason } = reqData;
      updateWarnRecord({ id, remark, warnReason }).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          Object.assign(curRow, this.editDataSet[row.id]);
          this.$delete(this.editDataSet, row.id);
          this.handleSearch(this.searchData);
        }
      });
    },
    cancel(row) {
      this.$delete(this.editDataSet, row.id);
    },
    handleSearch(data) {
      this.searchData = data;
      this.pageData.page = 1;
      this.getWarnRecordList(data);
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  height: calc(100vh - 50px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .filter {
    padding: 16px 24px 0px 24px;
    box-sizing: border-box;
    width: 100%;
    // height: 156px;
    border-radius: 4px;
    background: white;
    box-shadow: 0px 2px 12px #0000001f;
    .header-title {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 15px;
    }
    .header-tab {
      margin-top: 12px;
      /deep/ .el-tabs__item.is-active {
        color: #1890ff;
        font-weight: bold;
      }
    }
  }
  .table {
    box-sizing: border-box;
    margin-right: 16px;
    padding: 24px;
    margin-top: 16px;
    width: 100%;
    border-radius: 4px;
    background: #ffffff;
    box-shadow: 0px 2px 12px #0000001f;
    height: calc(100vh - 200px);
    flex: 1;
    overflow: hidden;
    .table-total {
      color: #000000d9;
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 12px;
    }
    .icon {
      font-size: 10px;
      margin-left: 4px;
      margin-bottom: 1px;
    }
  }
}
</style>
